import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Button from "../components/button"
import Bio from "../components/bio"

class IndexPage extends React.Component {
  render() {
    const siteTitle = "Kuge's Life"

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO
          title="首頁"
          keywords={[`自我提昇`, `兩性`, `自我成長`, `紅藥丸`]}
          description="分享關於自我提昇和兩性"
        />
        <h1>
          Welcome to my blog
        </h1>
        <h3>我的網站搬家了，請到新站 <a href="https://kugelife2.netlify.app/">Kugelife2</a>，Follow我的<a href="https://t.me/kgevolution">Telegram</a>或是<a href="https://t.co/NF2vaem7ut?amp=1">Facebook</a>以收到即時更新</h3>
        <Bio />
        <p>嗨，我因為想紀錄自己成長的過程，方便以後看看自己在想法上的變化，建立了這個部落格。也希望我的文章可以幫助一些人。</p>
        <p>Hey people! I started this blog to track my progress in the game of life and see how my way of thinking changes over the years. Hopefully you can get some insights from my posts.</p>
        <Link to="/blog/">
          <Button marginTop="35px">Go to Blog</Button>
        </Link>
      </Layout>
    )
  }
}

export default IndexPage
